import { useQuery } from '@tanstack/react-query';
import useHttpClient from './useHttpClient';
import { getOrgId } from '../fvid-auth/userSession';

interface IBillingSettings {
  isBillingEnabled: boolean;
  saveAsDraftDefault: boolean;
  saveAsDraftEnabled: boolean;
}

/**
 * TanStack Query version of useQueryBillingSettings
 * Fetches billing settings using HTTP client
 */
const useQueryBillingSettings = () => {
  const httpClient = useHttpClient();
  const orgId = getOrgId();

  return useQuery<IBillingSettings>({
    queryKey: ['billingSettings', orgId],
    queryFn: async () => {
      const response = await httpClient.get('/billing/org/settings');
      return response.data.billingSettings || response.data;
    },
    enabled: !!orgId, // Only fetch when orgId is available
  });
};

export default useQueryBillingSettings;
